var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10061IconServiceVirtualNetworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a1606a52-fb14-4637-87de-4d524bba1829",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f020fb7e-2243-4501-8153-5d69bd3c34f7",
    x1: 9.88,
    y1: 8.59,
    x2: 11.52,
    y2: 10.23,
    gradientTransform: "translate(2.03 -0.4) rotate(-0.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3c2bc94-8c7c-48a2-9719-6ee899a43a97",
    x1: 6.18,
    y1: 8.59,
    x2: 7.81,
    y2: 10.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e900c35d-0958-4d4f-b28f-302eeaaf52f5",
    x1: 2.48,
    y1: 8.59,
    x2: 4.11,
    y2: 10.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-networking-61") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 8.99,
    r: 1.16,
    fill: "url(#f020fb7e-2243-4501-8153-5d69bd3c34f7)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.04,
    cy: 9,
    r: 1.16,
    fill: "url(#b3c2bc94-8c7c-48a2-9719-6ee899a43a97)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.34,
    cy: 9,
    r: 1.16,
    fill: "url(#e900c35d-0958-4d4f-b28f-302eeaaf52f5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61,7.28h.94a.3.3,0,0,1,.3.3v6.94a.6.6,0,0,1-.6.6H2.31a0,0,0,0,1,0,0V7.58a.3.3,0,0,1,.3-.3Z",
    transform: "translate(13.18 16.93) rotate(134.92)",
    fill: "#50e6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56,2.91H3.5a.3.3,0,0,1,.3.3v7.43a0,0,0,0,1,0,0H2.86a.6.6,0,0,1-.6-.6V3.21a.3.3,0,0,1,.3-.3Z",
    transform: "translate(5.66 -0.16) rotate(44.92)",
    fill: "#1490df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.15,7.28h.94a.6.6,0,0,1,.6.6v6.94a.3.3,0,0,1-.3.3h-.94a.3.3,0,0,1-.3-.3V7.28a0,0,0,0,1,0,0Z",
    transform: "translate(12.32 -7.28) rotate(45.08)",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81,2.91h.94a0,0,0,0,1,0,0v7.43a.3.3,0,0,1-.3.3H14.5a.3.3,0,0,1-.3-.3V3.51a.6.6,0,0,1,.6-.6Z",
    transform: "translate(30.36 0.99) rotate(135.08)",
    fill: "#1490df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10061IconServiceVirtualNetworks);
export default __webpack_public_path__ + "static/media/10061-icon-service-Virtual-Networks.01b73b5ff5dd79f095ae2bfe3bf84974.svg";
export { ForwardRef as ReactComponent };